export default "__VITE_ASSET__CiEss8w0__"